import Tracker from './Tracker';
import { labelEvents } from './FileBrowser';

const CampaignsTracker = new Tracker('Campaigns', {
	...labelEvents
});

export default CampaignsTracker;
